/* global axios */
import ApiClient from './ApiClient';

// Grupos de etiquetas + vinculo de etiquetas por caixa (v77).
// Gerenciar grupo = so id 1 (guard no backend); leitura = qualquer papel.
class LabelGroupsAPI extends ApiClient {
  constructor() {
    super('label_groups', { accountScoped: true });
  }

  list() {
    return axios.get(this.url);
  }

  create(name, labelIds) {
    return axios.post(this.url, { name, label_ids: labelIds });
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, payload);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // Mapa das caixas configuradas -> titulos de etiqueta permitidos
  links() {
    return axios.get(`${this.baseUrl()}/inbox_label_links`);
  }

  getInboxConfig(inboxId) {
    return axios.get(`${this.baseUrl()}/inboxes/${inboxId}/labels_config`);
  }

  setInboxConfig(inboxId, { labelIds, labelGroupIds }) {
    return axios.post(`${this.baseUrl()}/inboxes/${inboxId}/set_labels_config`, {
      label_ids: labelIds,
      label_group_ids: labelGroupIds,
    });
  }
}

export default new LabelGroupsAPI();
